var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#0CAF6D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 24.5C24.5 24.7652 24.3946 25.0196 24.2071 25.2071C24.0196 25.3946 23.7652 25.5 23.5 25.5H14.5C14.2348 25.5 13.9804 25.3946 13.7929 25.2071C13.6054 25.0196 13.5 24.7652 13.5 24.5V13.5C13.5 13.2348 13.6054 12.9804 13.7929 12.7929C13.9804 12.6054 14.2348 12.5 14.5 12.5H21L24.5 16V24.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 20L19 22L17 20",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 22L19 16.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadSvg);
export default __webpack_public_path__ + "static/media/downloadSvg.f2e6b7b25609064bbca9e6124b88baba.svg";
export { ForwardRef as ReactComponent };